

export default {
  props: {
    organization: {
      type: Object,
      default: undefined,
      required: false
    },
    organizationType: {
      type: String,
      validator: val => ['buyer', 'seller'].includes(val),
      default: undefined
    },
    isCompetition: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      bookmark: false
    };
  },
  computed: {
    type () {
      if (this.organizationType) { return this.organizationType; }
      if (!this.organization) { return 'buyer'; }

      if (this.organization?.roles === 0) { return 'seller'; } // temporary fix.
      return ['buyer', 'seller', 'both'][this.organization.roles - 1];
    },

    address () {
      if (this.organization.cocAddress) {
        if (this.organization.cocAddress != null && this.organization.cocAddress.street != null) {
          return (this.organization.cocAddress.street + ', ' + this.organization.cocAddress.city);
        } else if (this.organization.cocAddress.street != null) {
          return this.organization.cocAddress.street;
        } else if (this.organization.cocAddress.city != null) {
          return this.organization.cocAddress.city;
        }
      }

      return 'Onbekend';
    },

    mainSbi () {
      if (this.organization.sbiCodes != null) { return this.organization.sbiCodes.find(sbiCode => sbiCode.isMainSbi); } else { return null; }
    },

    sector () {
      if (this.mainSbi?.longDescription) {
        return this.mainSbi.longDescription;
      } else if (this.organization?.mainActivity) {
        return this.organization.mainActivity;
      } else { return 'Onbekend'; }
    }
  }
};
